import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IgxCalendarModule, IgxListModule } from 'igniteui-angular';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';

import { TextFieldModule } from '@angular/cdk/text-field';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { CookieService } from 'ngx-cookie-service';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { AddAccountComponent } from './AddThings/add-account/add-account.component';
import { AddCustomerComponent } from './AddThings/add-customer/add-customer.component';
import { AddLoanComponent } from './AddThings/add-loan/add-loan.component';
import { AddPlanComponent } from './AddThings/add-plan/add-plan.component';
import { AddTransactionComponent } from './AddThings/add-transaction/add-transaction.component';
import { ApplyAssetComponent } from './AddThings/apply-asset/apply-asset.component';
import { CompanyCardComponent } from './Customer/company-card/company-card.component';
import { CustomerAlbumComponent } from './Customer/customer-album/customer-album.component';
import { CustomerContactListComponent } from './Customer/customer-contact-list/customer-contact-list.component';
import { CustomerDetailsComponent } from './Customer/customer-details/customer-details.component';
import { CustomerListComponent } from './Customer/customer-list/customer-list.component';
import { CustomerLoanCardComponent } from './Customer/customer-loan-card/customer-loan-card.component';
import { CustomerTaskListComponent } from './Customer/customer-task-list/customer-task-list.component';
import { ManageCustomerComponent } from './Customer/manage-customer/manage-customer.component';
import { DashboardAdminComponent } from './Dashboards/dashboard-admin/dashboard-admin.component';
import { DashboardCalendarComponent } from './Dashboards/dashboard-calendar/dashboard-calendar.component';
import { ContactCardComponent } from './Others/contact-card/contact-card.component';
import { ContactListComponent } from './Others/contact-list/contact-list.component';
import { LoginPageComponent } from './Others/login-page/login-page.component';
import { NavbarComponent } from './Others/navbar/navbar.component';
import { RegisterUserComponent } from './Others/register-user/register-user.component';
import { SidebarComponent } from './Others/sidebar/sidebar.component';
import { TaskDetailsComponent } from './Others/task-details/task-details.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthService } from './auth/auth.service';

import { DatePipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { APIAddress } from './API/apiAddresses';
import { RestApiService } from './API/restapi';
import { AccountListComponent } from './Account/account-list/account-list.component';
import { AddOtherTransactionsMenuComponent } from './Account/add-other-transactions-menu/add-other-transactions-menu.component';
import { DeleteReasonRemarkComponent } from './Account/delete-reason-remark/delete-reason-remark.component';
import { EditTransactionComponent } from './Account/edit-transaction/edit-transaction.component';
import { FundReallocationComponent } from './Account/fund-reallocation/fund-reallocation.component';
import { TransactionHistoryComponent } from './Account/transaction-history/transaction-history.component';
import { AddAdminRemarkComponent } from './AddThings/add-admin-remark/add-admin-remark.component';
import { AddAdvanceComponent } from './AddThings/add-advance/add-advance.component';
import { AddApprovedLoanComponent } from './AddThings/add-approved-loan/add-approved-loan.component';
import { AddAssetComponent } from './AddThings/add-asset/add-asset.component';
import { AddAssignedTransactionIntoAccountComponent } from './AddThings/add-assigned-transaction-into-account/add-assigned-transaction-into-account.component';
import { AddBadDebtWithdrawalComponent } from './AddThings/add-bad-debt-withdrawal/add-bad-debt-withdrawal.component';
import { AddCapitalComponent } from './AddThings/add-capital/add-capital.component';
import { AddCompanyComponent } from './AddThings/add-company/add-company.component';
import { AddContactComponent } from './AddThings/add-contact/add-contact.component';
import { AddCpPaymentComponent } from './AddThings/add-cp-payment/add-cp-payment.component';
import { AddDuitLebihComponent } from './AddThings/add-duit-lebih/add-duit-lebih.component';
import { AddExpensesComponent } from './AddThings/add-expenses/add-expenses.component';
import { AddHutangRequestComponent } from './AddThings/add-hutang-request/add-hutang-request.component';
import { AddIncomeComponent } from './AddThings/add-income/add-income.component';
import { AddMultipleTransactionComponent } from './AddThings/add-multiple-transaction/add-multiple-transaction.component';
import { AddPaymentModalComponent } from './AddThings/add-payment-modal/add-payment-modal.component';
import { AddPrincipalComponent } from './AddThings/add-principal/add-principal.component';
import { AddProfileComponent } from './AddThings/add-profile/add-profile.component';
import { AddPulledCustomerRecordComponent } from './AddThings/add-pulled-customer-record/add-pulled-customer-record.component';
import { AddSavingComponent } from './AddThings/add-saving/add-saving.component';
import { AddSubtypeComponent } from './AddThings/add-subtype/add-subtype.component';
import { AddTotingComponent } from './AddThings/add-toting/add-toting.component';
import { AddTransactionRequestComponent } from './AddThings/add-transaction-request/add-transaction-request.component';
import { AddWithdrawalComponent } from './AddThings/add-withdrawal/add-withdrawal.component';
import { AddedDuitLebihListComponent } from './AddThings/added-duit-lebih-list/added-duit-lebih-list.component';
import { BadDebtSimpanExpenseComponent } from './AddThings/bad-debt-simpan-expense/bad-debt-simpan-expense.component';
import { ManageTransactionSubtypeComponent } from './AddThings/manage-transaction-subtype/manage-transaction-subtype.component';
import { TransferFundComponent } from './AddThings/transfer-fund/transfer-fund.component';
import { AdvanceListComponent } from './Advance/advance-list/advance-list.component';
import { PayAdvanceComponent } from './Advance/pay-advance/pay-advance.component';
import { AddBlacklistCustomerComponent } from './Blacklist/add-blacklist-customer/add-blacklist-customer.component';
import { BlacklistCustomerListComponent } from './Blacklist/blacklist-customer-list/blacklist-customer-list.component';
import { CompareCpPaymentsComponent } from './CP/compare-cp-payments/compare-cp-payments.component';
import { CpCustomerListComponent } from './CP/cp-customer-list/cp-customer-list.component';
import { CpOverviewComponent } from './CP/cp-overview/cp-overview.component';
import { ViewCpDetailsComponent } from './CP/view-cp-details/view-cp-details.component';
import { AddCommissionPaymentComponent } from './Comission/add-commission-payment/add-commission-payment.component';
import { AddCommissionComponent } from './Comission/add-commission/add-commission.component';
import { AddCommissionsComponent } from './Comission/add-commissions/add-commissions.component';
import { AssignCommissionComponent } from './Comission/assign-commission/assign-commission.component';
import { ComissionListComponent } from './Comission/comission-list/comission-list.component';
import { EditCommissionComponent } from './Comission/edit-commission/edit-commission.component';
import { CompanyDetailCardComponent } from './Company/company-detail-card/company-detail-card.component';
import { CompanyListComponent } from './Company/company-list/company-list.component';
import { ManageCompanyAccessComponent } from './Company/manage-company-access/manage-company-access.component';
import { UpdateCompanyComponent } from './Company/update-company/update-company.component';
import { CheckCustomerNecessaryFilesComponent } from './Customer/check-customer-necessary-files/check-customer-necessary-files.component';
import { CustomerAdminRemarkComponent } from './Customer/customer-admin-remark/customer-admin-remark.component';
import { CustomerBdHistoryComponent } from './Customer/customer-bd-history/customer-bd-history.component';
import { CustomerLeadListComponent } from './Customer/customer-lead-list/customer-lead-list.component';
import { CustomerLoanRequestHistoryComponent } from './Customer/customer-loan-request-history/customer-loan-request-history.component';
import { CustomerTransactionsComponent } from './Customer/customer-transactions/customer-transactions.component';
import { EditEpfDetailsComponent } from './Customer/edit-epf-details/edit-epf-details.component';
import { GuarantorFormComponent } from './Customer/guarantor-form/guarantor-form.component';
import { IcChangeHistoryComponent } from './Customer/ic-change-history/ic-change-history.component';
import { MergeProfileComponent } from './Customer/merge-profile/merge-profile.component';
import { UpdateCustomerComponent } from './Customer/update-customer/update-customer.component';
import { UpdateProfileInfoComponent } from './Customer/update-profile-info/update-profile-info.component';
import { VerifyCustomerComponent } from './Customer/verify-customer/verify-customer.component';
import { ViewCustomerRemarkComponent } from './Customer/view-customer-remark/view-customer-remark.component';
import { ViewEpfChangeHistoryComponent } from './Customer/view-epf-change-history/view-epf-change-history.component';
import { AssignedTransactionCardComponent } from './Dashboards/assigned-transaction-card/assigned-transaction-card.component';
import { DueEpfListComponent } from './Dashboards/due-epf-list/due-epf-list.component';
import { NextTaskComponent } from './Dashboards/follow-next-task/follow-next-task.component';
import { UsageReportCardComponent } from './Dashboards/usage-report-card/usage-report-card.component';
import { FormJHistoryComponent } from './FormJ/form-j-history/form-j-history.component';
import { FormJScheduleComponent } from './FormJ/form-j-schedule/form-j-schedule.component';
import { FormJComponent } from './FormJ/form-j/form-j.component';
import { FormjReceiptLetterComponent } from './FormJ/formj-receipt-letter/formj-receipt-letter.component';
import { GenerateFormjComponent } from './FormJ/generate-formj/generate-formj.component';
import { PaymentVoucherComponent } from './FormJ/payment-voucher/payment-voucher.component';
import { AlbumComponentComponent } from './Images/album-component/album-component.component';
import { EnlargeImageComponent } from './Images/enlarge-image/enlarge-image.component';
import { UploadImageComponent } from './Images/upload-image/upload-image.component';
import { ImportExcelComponent } from './Import/import-excel/import-excel.component';
import { ImportNewCompanyComponent } from './Import/import-new-company/import-new-company.component';
import { AddPaymentComponent } from './LoanPayment/add-payment/add-payment.component';
import { BatchPaymentComponent } from './LoanPayment/batch-payment/batch-payment.component';
import { OverlapComponentComponent } from './LoanPayment/overlap-component/overlap-component.component';
import { AddLoanRequestGuarantorComponent } from './LoanRequest/add-loan-request-guarantor/add-loan-request-guarantor.component';
import { AllLoanRequestCardComponent } from './LoanRequest/all-loan-request-card/all-loan-request-card.component';
import { AuthorizeLoanRequestComponent } from './LoanRequest/authorize-loan-request/authorize-loan-request.component';
import { EditLoanRequestInfoComponent } from './LoanRequest/edit-loan-request-info/edit-loan-request-info.component';
import { EditLoanRequestRemarkComponent } from './LoanRequest/edit-loan-request-remark/edit-loan-request-remark.component';
import { ElevateConfirmationComponent } from './LoanRequest/elevate-confirmation/elevate-confirmation.component';
import { EpfLimitInformationComponent } from './LoanRequest/epf-limit-information/epf-limit-information.component';
import { EpfRequestCalculatorComponent } from './LoanRequest/epf-request-calculator/epf-request-calculator.component';
import { LoanRequestApprovalComponent } from './LoanRequest/loan-request-approval/loan-request-approval.component';
import { LoanRequestDetailsComponent } from './LoanRequest/loan-request-details/loan-request-details.component';
import { LoanRequestListComponent } from './LoanRequest/loan-request-list/loan-request-list.component';
import { PreviousApprovedRequestCardComponent } from './LoanRequest/previous-approved-request-card/previous-approved-request-card.component';
import { ReviewLoanRequestComponent } from './LoanRequest/review-loan-request/review-loan-request.component';
import { AddLoanDetailsComponent } from './Loans/add-loan-details/add-loan-details.component';
import { ChangeLoanStatusComponent } from './Loans/change-loan-status/change-loan-status.component';
import { LegacyEpfSettlementComponent } from './Loans/legacy-epf-settlement/legacy-epf-settlement.component';
import { LoanArrearComponent } from './Loans/loan-arrear/loan-arrear.component';
import { LoanCardComponent } from './Loans/loan-card/loan-card.component';
import { LoanDetailsComponent } from './Loans/loan-details/loan-details.component';
import { LoanReserveComponent } from './Loans/loan-reserve/loan-reserve.component';
import { MarkLegacyEpfsComponent } from './Loans/mark-legacy-epfs/mark-legacy-epfs.component';
import { MoveLoanComponent } from './Loans/move-loan/move-loan.component';
import { LoanRequestMessageComponent } from './MessageClipboard/loan-request-message/loan-request-message.component';
import { CompareSettlementInfoListComponent } from './Others/compare-settlement-info-list/compare-settlement-info-list.component';
import { ConflictedCustomerListComponent } from './Others/conflicted-customer-list/conflicted-customer-list.component';
import { DeleteReasonComponent } from './Others/delete-reason/delete-reason.component';
import { DeployWebappComponent } from './Others/deploy-webapp/deploy-webapp.component';
import { GlobalSearchCustomerComponent } from './Others/global-search-customer/global-search-customer.component';
import { IdleTimeoutComponent } from './Others/idle-timeout/idle-timeout.component';
import { MaintenanceModeToggleComponent } from './Others/maintenance-mode-toggle/maintenance-mode-toggle.component';
import { SearchByReceiptComponent } from './Others/search-by-receipt/search-by-receipt.component';
import { SearchTaskComponent } from './Others/search-task/search-task.component';
import { ServerStatusPageComponent } from './Others/server-status-page/server-status-page.component';
import { TaskCollectionListComponent } from './Others/task-collection-list/task-collection-list.component';
import { ValidateEpfStatementComponent } from './Others/validate-epf-statement/validate-epf-statement.component';
import { AssetSummaryReportComponent } from './Report/asset-summary-report/asset-summary-report.component';
import { CashBalanceReportComponent } from './Report/cash-balance-report/cash-balance-report.component';
import { CashBookReportComponent } from './Report/cash-book-report/cash-book-report.component';
import { CheckInHistoryComponent } from './Report/check-in-history/check-in-history.component';
import { CompanySummaryReportComponent } from './Report/company-summary-report/company-summary-report.component';
import { CustomerRecordReportComponent } from './Report/customer-record-report/customer-record-report.component';
import { DailyReportComponent } from './Report/daily-report/daily-report.component';
import { DuitLebihReportComponent } from './Report/duit-lebih-report/duit-lebih-report.component';
import { FormJReportComponent } from './Report/form-j-report/form-j-report.component';
import { ListHutangReportComponent } from './Report/list-hutang-report/list-hutang-report.component';
import { LoanSchemeReportComponent } from './Report/loan-scheme-report/loan-scheme-report.component';
import { MidMonthReportComponent } from './Report/mid-month-report/mid-month-report.component';
import { OverdueEpfReportComponent } from './Report/overdue-epf-report/overdue-epf-report.component';
import { ReportGeneratorComponent } from './Report/report-generator/report-generator.component';
import { ReportMenuComponent } from './Report/report-menu/report-menu.component';
import { SimpleReportComponent } from './Report/simple-report/simple-report.component';
import { StockComponentComponent } from './Report/stock-component/stock-component.component';
import { StockReportComponent } from './Report/stock-report/stock-report.component';
import { UsageReportComponent } from './Report/usage-report/usage-report.component';
import { VerifyAccountComponent } from './Report/verify-account/verify-account.component';
import { AddSimpanComponent } from './Reserve/add-simpan/add-simpan.component';
import { ExpenseSimpanComponent } from './Reserve/expense-simpan/expense-simpan.component';
import { ReserveHistoryComponent } from './Reserve/reserve-history/reserve-history.component';
import { TransferSimpanComponent } from './Reserve/transfer-simpan/transfer-simpan.component';
import { WithdrawSimpanComponent } from './Reserve/withdraw-simpan/withdraw-simpan.component';
import { AddReceiptSetComponent } from './Sets/add-receipt-set/add-receipt-set.component';
import { ReceiptAddExpenseAdminRemarkComponent } from './Sets/receipt-add-expense-admin-remark/receipt-add-expense-admin-remark.component';
import { ReceiptDetailsComponent } from './Sets/receipt-details/receipt-details.component';
import { ReceiptSetsListComponent } from './Sets/receipt-sets-list/receipt-sets-list.component';
import { ReceiptSetsListviewComponent } from './Sets/receipt-sets-listview/receipt-sets-listview.component';
import { ShowUnprocessedSetTransactionComponent } from './Sets/show-unprocessed-set-transaction/show-unprocessed-set-transaction.component';
import { AlertDialogComponent } from './Shared/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from './Shared/confirmation-dialog/confirmation-dialog.component';
import { NoRightClickDirective } from './Shared/no-right-click.directive';
import { ScrollToTopComponent } from './Shared/scroll-to-top/scroll-to-top.component';
import { SelectAllComponent } from './Shared/select-all/select-all.component';
import { SharedAddRemarkComponent } from './Shared/shared-add-remark/shared-add-remark.component';
import { EditProfileComponent } from './User/edit-profile/edit-profile.component';
import { EditUserComponent } from './User/edit-user/edit-user.component';
import { UserListComponent } from './User/user-list/user-list.component';
import { CpPaymentSheetComponent } from './cp-payment-sheet/cp-payment-sheet.component';
import { NoscrollDirective } from './noscroll.directive';

import { AddLoanRequestDetailsComponent } from './LoanRequest/add-loan-request-details/add-loan-request-details.component';
import { SearchCompanyByUidComponent } from './Others/search-company-by-uid/search-company-by-uid.component';
import { AddReserveGroupComponent } from './Reserve/add-reserve-group/add-reserve-group.component';
import { ViewReserveGroupsComponent } from './Reserve/view-reserve-groups/view-reserve-groups.component';
import { SharedLoanAgreementComponent } from './SharedLoan/shared-loan-agreement/shared-loan-agreement.component';
import { SharedLoanRequestCardComponent } from './SharedLoan/shared-loan-request-card/shared-loan-request-card.component';
import { SharedLoanComponent } from './SharedLoan/shared-loan/shared-loan.component';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { AddBankInAccountComponent } from './AddThings/add-bank-in-account/add-bank-in-account.component';
import { AccessActionComponent } from './AdminAccess/access-action/access-action.component';
import { AdminAccessItemComponent } from './AdminAccess/admin-access-item/admin-access-item.component';
import { AdminAccessManagementComponent } from './AdminAccess/admin-access-management/admin-access-management.component';
import { AdminAccessTableComponent } from './AdminAccess/admin-access-table/admin-access-table.component';
import { AdminCompanyListComponent } from './AdminAccess/admin-company-list/admin-company-list.component';
import { ApplyAssetRequestComponent } from './AssetRequest/apply-asset-request/apply-asset-request.component';
import { AssetApplyDetailsComponent } from './AssetRequest/asset-apply-details/asset-apply-details.component';
import { AssetContraDetailsComponent } from './AssetRequest/asset-contra-details/asset-contra-details.component';
import { AssetRequestSummaryComponent } from './AssetRequest/asset-request-summary/asset-request-summary.component';
import { AssetReturnCashComponent } from './AssetRequest/asset-return-cash/asset-return-cash.component';
import { AssetSharedBranchListComponent } from './AssetRequest/asset-shared-branch-list/asset-shared-branch-list.component';
import { AssetSheetRequestLogComponent } from './AssetRequest/asset-sheet-request-log/asset-sheet-request-log.component';
import { ManageApprovedBankInAccountComponent } from './AssetRequest/manage-approved-bank-in-account/manage-approved-bank-in-account.component';
import { SelectApprovedTicketComponent } from './AssetRequest/select-approved-ticket/select-approved-ticket.component';
import { AccountAuthorizationCardComponent } from './BankAccount/account-authorization-card/account-authorization-card.component';
import { AccountAuthorizationLetterComponent } from './BankAccount/account-authorization-letter/account-authorization-letter.component';
import { AccountAuthorizationHistoryComponent } from './BankAccount/accountAuthorizationHistory/accountAuthorizationHistory.component';
import { AddAccountAuthorizationRequestComponent } from './BankAccount/add-account-authorization-request/add-account-authorization-request.component';
import { AddCustomerBankAccountComponent } from './BankAccount/add-customer-bank-account/add-customer-bank-account.component';
import { BankAccountDetailComponent } from './BankAccount/bank-account-detail/bank-account-detail.component';
import { ProcessAuthorizationComponent } from './BankAccount/process-authorization/process-authorization.component';
import { EditBlacklistComponent } from './Blacklist/edit-blacklist/edit-blacklist.component';
import { AddUpdateBusinessComponent } from './BusinessLicense/add-update-business/add-update-business.component';
import { AddUpdateLicenseComponent } from './BusinessLicense/add-update-license/add-update-license.component';
import { BusinessListComponent } from './BusinessLicense/business-list/business-list.component';
import { LicenseListComponent } from './BusinessLicense/license-list/license-list.component';
import { MaintainBusinessLicenseComponent } from './BusinessLicense/maintain-business-license/maintain-business-license.component';
import { SelectBusinessLicenseComponent } from './BusinessLicense/select-business-license/select-business-license.component';
import { OverrideCommLimitComponent } from './Comission/override-comm-limit/override-comm-limit.component';
import { PreviousAssignedCommissionComponent } from './Comission/previous-assigned-commission/previous-assigned-commission.component';
import { CustomerAccountListComponent } from './Customer/customer-account-list/customer-account-list.component';
import { GuarantorAgreementFormComponent } from './Customer/guarantor-agreement-form/guarantor-agreement-form.component';
import { RepaymentCompareComponent } from './Customer/repayment-compare/repayment-compare.component';
import { ShareProfileToCompanyComponent } from './Customer/share-profile-to-company/share-profile-to-company.component';
import { AccountAuthorizationListComponent } from './Dashboards/account-authorization-list/account-authorization-list.component';
import { AddFinanceAccountComponent } from './FinanceAccount/add-finance-account/add-finance-account.component';
import { FinanceAccountListComponent } from './FinanceAccount/finance-account-list/finance-account-list.component';
import { ImageViewerComponent } from './Images/image-viewer/image-viewer.component';
import { ThumbnailsListComponent } from './Images/thumbnails-list/thumbnails-list.component';
import { DraftCalculatorComponent } from './LoanRequest/draft-calculator/draft-calculator.component';
import { SearchTicketComponent } from './LoanRequest/search-ticket/search-ticket.component';
import { EpfSettlementBreakdownLetterComponent } from './Loans/epf-settlement-breakdown-letter/epf-settlement-breakdown-letter.component';
import { MessageClipboardComponent } from './MessageClipboard/message-clipboard/message-clipboard.component';
import { UpdateCommissionMessageComponent } from './MessageClipboard/update-commission-message/update-commission-message.component';
import { AuthLogComponent } from './Others/auth-log/auth-log.component';
import { BookmarkItemComponent } from './Others/bookmark-item/bookmark-item.component';
import { BookmarkComponent } from './Others/bookmark/bookmark.component';
import { SpinnerComponent } from './Others/spinner/spinner.component';
import { ChargesBalanceSummaryComponent } from './Report/charges-balance-summary/charges-balance-summary.component';
import { StampHQSummaryComponent } from './Report/stamp-hqsummary/stamp-hqsummary.component';
import { UnsubmittedReserveGroupListComponent } from './Reserve/unsubmitted-reserve-group-list/unsubmitted-reserve-group-list.component';
import { ReceiptTodoComponent } from './Sets/receipt-todo/receipt-todo.component';
import { SharedLoanListComponent } from './SharedLoan/shared-loan-list/shared-loan-list.component';
import { AddUpdateBusinessBranchComponent } from './add-update-business-branch/add-update-business-branch.component';
import { AddUpdateFiscalYearInfoComponent } from './add-update-fiscal-year-info/add-update-fiscal-year-info.component';
import { AutoSelectDirective } from './auto-select.directive';
import { BankRedemptionLetterComponent } from './bank-redemption-letter/bank-redemption-letter.component';
import { BusinessBranchListComponent } from './business-branch-list/business-branch-list.component';
import { BusinessFinanceAccountListComponent } from './business-finance-account-list/business-finance-account-list.component';
import { ChangeBusinessBranchComponent } from './change-business-branch/change-business-branch.component';
import { EInvoiceDocListComponent } from './e-invoice-doc-list/e-invoice-doc-list.component';
import { EnGbDateAdapter } from './enGB-date-adapter';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { FiscalYearInfoListComponent } from './fiscal-year-info-list/fiscal-year-info-list.component';
import { FormJSelectionComponent } from './form-j-selection/form-j-selection.component';
import { LinkedBusinessListComponent } from './linked-business-list/linked-business-list.component';
import { StopPropagationDirective } from './stop-propagation.directive';
import { DocusealHistoryComponent } from './Others/docuseal-history/docuseal-history.component';

@NgModule({
	declarations: [
		AppComponent,
		SidebarComponent,
		ApplyAssetComponent,
		AddTransactionComponent,
		EditProfileComponent,
		AddCustomerComponent,
		ContactListComponent,
		ContactCardComponent,
		AddPlanComponent,
		DashboardCalendarComponent,
		ManageCustomerComponent,
		CustomerContactListComponent,
		CustomerTaskListComponent,
		CustomerAlbumComponent,
		CompanyCardComponent,
		CustomerLoanCardComponent,
		DashboardAdminComponent,
		CustomerListComponent,
		AddAccountComponent,
		CustomerDetailsComponent,
		AddLoanComponent,
		LoginPageComponent,
		TaskDetailsComponent,
		RegisterUserComponent,
		NavbarComponent,
		CompanyListComponent,
		CompanyDetailCardComponent,
		TransactionHistoryComponent,
		AddPaymentComponent,
		LoanDetailsComponent,
		LoanCardComponent,
		AddContactComponent,
		UpdateCustomerComponent,
		AddCompanyComponent,
		ConfirmationDialogComponent,
		UserListComponent,
		UpdateCompanyComponent,
		GlobalSearchCustomerComponent,
		LoanReserveComponent,
		FundReallocationComponent,
		TaskCollectionListComponent,
		AccountListComponent,
		ReserveHistoryComponent,
		LoanArrearComponent,
		AddIncomeComponent,
		StockReportComponent,
		AddExpensesComponent,
		ReportMenuComponent,
		AddPrincipalComponent,
		AddAssetComponent,
		AddAdvanceComponent,
		AdvanceListComponent,
		PayAdvanceComponent,
		UploadImageComponent,
		EnlargeImageComponent,
		NoRightClickDirective,
		AddCpPaymentComponent,
		SearchTaskComponent,
		AlertDialogComponent,
		ComissionListComponent,
		AddCommissionPaymentComponent,
		SimpleReportComponent,
		ReportGeneratorComponent,
		CashBookReportComponent,
		ListHutangReportComponent,
		LoanSchemeReportComponent,
		TransferFundComponent,
		EditUserComponent,
		AddCapitalComponent,
		AddSavingComponent,
		AddWithdrawalComponent,
		AssetSummaryReportComponent,
		SearchByReceiptComponent,
		BadDebtSimpanExpenseComponent,
		AddCommissionsComponent,
		AssignCommissionComponent,
		EditTransactionComponent,
		AddLoanDetailsComponent,
		EditCommissionComponent,
		AddBadDebtWithdrawalComponent,
		AddCommissionComponent,
		AddSubtypeComponent,
		AddDuitLebihComponent,
		AddedDuitLebihListComponent,
		DuitLebihReportComponent,
		AddSimpanComponent,
		WithdrawSimpanComponent,
		BatchPaymentComponent,
		AddPaymentModalComponent,
		ImportNewCompanyComponent,
		ImportExcelComponent,
		CustomerTransactionsComponent,
		FormJComponent,
		FormJScheduleComponent,
		FormJHistoryComponent,
		GenerateFormjComponent,
		PaymentVoucherComponent,
		FormjReceiptLetterComponent,
		UpdateProfileInfoComponent,
		AddProfileComponent,
		CustomerBdHistoryComponent,
		CashBalanceReportComponent,
		CustomerLeadListComponent,
		CustomerAdminRemarkComponent,
		AddAdminRemarkComponent,
		ViewCustomerRemarkComponent,
		DeleteReasonRemarkComponent,
		MidMonthReportComponent,
		UsageReportComponent,
		TransferSimpanComponent,
		DailyReportComponent,
		FormJReportComponent,
		CompanySummaryReportComponent,
		VerifyAccountComponent,
		StockComponentComponent,
		CheckInHistoryComponent,
		IdleTimeoutComponent,
		ChangeLoanStatusComponent,
		MergeProfileComponent,
		ExpenseSimpanComponent,
		NoscrollDirective,
		AddTotingComponent,
		DeleteReasonComponent,
		AddOtherTransactionsMenuComponent,
		AddMultipleTransactionComponent,
		MaintenanceModeToggleComponent,
		DueEpfListComponent,
		LoanRequestMessageComponent,
		LoanRequestListComponent,
		AddApprovedLoanComponent,
		LoanRequestDetailsComponent,
		AllLoanRequestCardComponent,
		ReviewLoanRequestComponent,
		UsageReportCardComponent,
		NextTaskComponent,
		PreviousApprovedRequestCardComponent,
		MarkLegacyEpfsComponent,
		EpfRequestCalculatorComponent,
		CustomerLoanRequestHistoryComponent,
		EditEpfDetailsComponent,
		EditLoanRequestInfoComponent,
		OverlapComponentComponent,
		CustomerRecordReportComponent,
		AddLoanRequestGuarantorComponent,
		ServerStatusPageComponent,
		OverdueEpfReportComponent,
		AuthorizeLoanRequestComponent,
		LegacyEpfSettlementComponent,
		EpfLimitInformationComponent,
		GuarantorFormComponent,
		AddHutangRequestComponent,
		ElevateConfirmationComponent,
		AddReceiptSetComponent,
		ReceiptSetsListComponent,
		ReceiptDetailsComponent,
		ReceiptTodoComponent,
		MoveLoanComponent,
		ShowUnprocessedSetTransactionComponent,
		EditLoanRequestRemarkComponent,
		VerifyCustomerComponent,
		CheckCustomerNecessaryFilesComponent,
		AlbumComponentComponent,
		DeployWebappComponent,
		ManageCompanyAccessComponent,
		CompareSettlementInfoListComponent,
		SharedAddRemarkComponent,
		ReceiptSetsListviewComponent,
		ReceiptAddExpenseAdminRemarkComponent,
		ManageTransactionSubtypeComponent,
		ScrollToTopComponent,
		ViewCpDetailsComponent,
		CpCustomerListComponent,
		CpOverviewComponent,
		CpPaymentSheetComponent,
		CompareCpPaymentsComponent,
		AddTransactionRequestComponent,
		AssignedTransactionCardComponent,
		AddAssignedTransactionIntoAccountComponent,
		ConflictedCustomerListComponent,
		ViewEpfChangeHistoryComponent,
		IcChangeHistoryComponent,
		SelectAllComponent,
		LoanRequestApprovalComponent,
		AddPulledCustomerRecordComponent,
		AddBlacklistCustomerComponent,
		BlacklistCustomerListComponent,
		ValidateEpfStatementComponent,
		SharedLoanComponent,
		AddLoanRequestDetailsComponent,
		SharedLoanAgreementComponent,
		AddReserveGroupComponent,
		ViewReserveGroupsComponent,
		SearchCompanyByUidComponent,
		SharedLoanRequestCardComponent,
		SearchTicketComponent,
		ShareProfileToCompanyComponent,
		SharedLoanListComponent,
		BookmarkComponent,
		DraftCalculatorComponent,
		EpfSettlementBreakdownLetterComponent,
		BankAccountDetailComponent,
		AddAccountAuthorizationRequestComponent,
		AccountAuthorizationLetterComponent,
		AddCustomerBankAccountComponent,
		CustomerAccountListComponent,
		AccountAuthorizationHistoryComponent,
		AccountAuthorizationCardComponent,
		AccountAuthorizationListComponent,
		ProcessAuthorizationComponent,
		AdminAccessManagementComponent,
		AdminAccessItemComponent,
		AdminAccessTableComponent,
		AccessActionComponent,
		AdminCompanyListComponent,
		EditBlacklistComponent,
		AuthLogComponent,
		OverrideCommLimitComponent,
		MessageClipboardComponent,
		UpdateCommissionMessageComponent,
		RepaymentCompareComponent,
		UnsubmittedReserveGroupListComponent,
		SpinnerComponent,
		PreviousAssignedCommissionComponent,
		ChargesBalanceSummaryComponent,
		StopPropagationDirective,
		MaintainBusinessLicenseComponent,
		AddUpdateBusinessComponent,
		AddUpdateLicenseComponent,
		LicenseListComponent,
		BusinessListComponent,
		FiscalYearInfoListComponent,
		SelectBusinessLicenseComponent,
		FormJSelectionComponent,
		FileUploaderComponent,
		ThumbnailsListComponent,
		ImageViewerComponent,
		ApplyAssetRequestComponent,
		AddBankInAccountComponent,
		AssetReturnCashComponent,
		AssetApplyDetailsComponent,
		ManageApprovedBankInAccountComponent,
		SelectApprovedTicketComponent,
		AssetRequestSummaryComponent,
		AssetContraDetailsComponent,
		AssetSharedBranchListComponent,
		AssetSheetRequestLogComponent,
		FinanceAccountListComponent,
		AddFinanceAccountComponent,
		BusinessFinanceAccountListComponent,
		LinkedBusinessListComponent,
		BankRedemptionLetterComponent,
		AutoSelectDirective,
		GuarantorAgreementFormComponent,
		StampHQSummaryComponent,
		BusinessBranchListComponent,
		AddUpdateBusinessBranchComponent,
		ChangeBusinessBranchComponent,
		AddUpdateFiscalYearInfoComponent,
		DocusealHistoryComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		NgbModule,
		BrowserAnimationsModule,
		IgxCalendarModule,
		IgxListModule,
		MatPaginatorModule,
		MatTableModule,
		MatSortModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatAutocompleteModule,
		FormsModule,
		ReactiveFormsModule,
		TextFieldModule,
		MatDatepickerModule,
		MatTimepickerModule,
		MatNativeDateModule,
		MatTabsModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatTooltipModule,
		NgxPanZoomModule,
		MatCheckboxModule,
		MatExpansionModule,
		MatProgressSpinnerModule,
		MatSlideToggleModule,
		MatStepperModule,
		MatSnackBarModule,
		MatChipsModule,
		ClipboardModule,
		MatRadioModule,
		NgIdleKeepaliveModule.forRoot(),
		BookmarkItemComponent,
		EInvoiceDocListComponent
	],
	exports: [EpfRequestCalculatorComponent],
	providers: [
		AuthService,
		CookieService,
		AuthGuard,
		NgbActiveModal,
		RestApiService,
		APIAddress,
		DatePipe,
		{ provide: LOCALE_ID, useValue: 'en-GB' },
		{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
		{ provide: DateAdapter, useClass: EnGbDateAdapter },
		provideHttpClient(withInterceptorsFromDi())
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
